export enum FilterRequestType {
    Equal = "Equal",
    NotEqual = "NotEqual",
    Greater = "Greater",
    Less = "Less",
    GreaterOrEqual = "GreaterOrEqual",
    LessOrEqual = "LessOrEqual",
    Contains = "Contains",
    NotContains = "NotContains",
    StartsWith = "StartsWith",
    EndsWith = "EndsWith",
    NotStartsWith = "NotStartsWith",
    NotEndsWith = "NotEndsWith"
}
